import { LocationPermissionStatus } from './getLocationPermission.types';

const debug = require('debug')('tca:kit:utilities:getLocationPermission');

export const getLocationPermission =
  async (): Promise<LocationPermissionStatus> => {
    try {
      if (!navigator.permissions || !navigator.permissions.query) {
        return 'unavailable';
      }

      const result = await navigator.permissions.query({ name: 'geolocation' });

      debug(`Web location permission check ${result.state}`);

      if (result.state === 'granted') {
        return 'granted';
      }

      if (result.state === 'denied') {
        return 'blocked';
      }

      return 'denied';
    } catch (error) {
      debug(`Web location permission error: ${JSON.stringify(error)}`);

      return 'unavailable';
    }
  };
